import { endpoints } from 'modules/endpoints'
import { ApiService } from 'service/api/interface'
import { Sku } from './types'

export const getSkuById = (apiClient: ApiService) => (id: string) => apiClient.get<Sku>(endpoints.sku(id))
